"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateIdentityProofKycDocumentPageOptions = void 0;
class CreateIdentityProofKycDocumentPageOptions {
    mangopayId;
    kycDocumentId;
    file; // in base64
}
exports.CreateIdentityProofKycDocumentPageOptions = CreateIdentityProofKycDocumentPageOptions;
//# sourceMappingURL=CreateIdentityProofKycDocumentPageOptions.js.map